const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/zakovat",
  },
  actions: {
    // Savollar bazasi (banks)
    "get-banks"({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/banks?${serialize(options)}`, method: "GET", data: {} }, { root: true });
    },
    "add-bank"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/banks/add`, method: "POST", data }, { root: true });
    },
    "update-bank"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/banks/update`, method: "POST", data }, { root: true });
    },
    "delete-bank"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/banks/delete`, method: "POST", data }, { root: true });
    },

    // Questions
    "get-questions"({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/questions?${serialize(options)}`, method: "GET", data: {} }, { root: true });
    },
    "add-question"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/questions/add`, method: "POST", data }, { root: true });
    },
    "update-question"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/questions/update`, method: "POST", data }, { root: true });
    },
    "delete-question"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/questions/delete`, method: "POST", data }, { root: true });
    },
    "get-image"({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/image?${serialize(options)}`, method: "GET", data: {} }, { root: true });
    },

    // Zakovat groups (yangi)
    "get-groups"({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/groups?${serialize(options)}`, method: "GET", data: {} }, { root: true });
    },
    "get-group"({ dispatch, state, rootState }, id) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/groups/${id}`, method: "GET", data: {} }, { root: true });
    },
    "add-group"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/groups/add`, method: "POST", data }, { root: true });
    },
    "update-group"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/groups/update`, method: "POST", data }, { root: true });
    },
    "delete-group"({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/groups/delete`, method: "POST", data }, { root: true });
    },
    "eligible-students"({ dispatch, state, rootState }, id) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/groups/${id}/eligible-students`, method: "GET", data: {} }, { root: true });
    },
    "save-students"({ dispatch, state, rootState }, { id, studentIds }) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/groups/${id}/students`, method: "POST", data: { studentIds } }, { root: true });
    },
    "save-config"({ dispatch, state, rootState }, { id, sciencesOptions, durationMinutes, scheduledAt }) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/groups/${id}/config`, method: "POST", data: { sciencesOptions, durationMinutes, scheduledAt } }, { root: true });
    },
    "get-leaderboard"({ dispatch, state, rootState }, id) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/groups/${id}/leaderboard`, method: "GET", data: {} }, { root: true });
    },

    // Results
    "get-results"({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/results?${serialize(options)}`, method: "GET", data: {} }, { root: true });
    },
    "get-result"({ dispatch, state, rootState }, resultId) {
      if (rootState.authenticated) return dispatch("FETCH", { url: `${state.path}/results/${resultId}`, method: "GET", data: {} }, { root: true });
    },
  },
};
